import React, { Component  } from 'react';
import { NavigationActions } from '../../actions';
import { isMobileOnly      } from "react-device-detect";
import logo from '../../assets/logo-icon.png';
import { History as history, Routes as routes } from '../../navigation';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger'

import '../../css/common/TitleBar.css';

class TitleBar extends Component {

  componentDidMount() {
    if (this.props.userActions) {
      this.props.userActions.subToNotifSocket();
    }
  }

  renderPopoverList = () => {
    return <div className="title-bar-popover">
      <div className="title-bar-popover-button">Switch Role</div>
      <div className="title-bar-popover-button">Switch Practice</div>
      <div className="title-bar-popover-button">Sign Out</div>
    </div>
  }

  renderPopover = () => {
    const triggerSection = this.renderCurrentlyLoggedIn(this.props.selectedPractice, this.props.selectedRole);

    if (!triggerSection) {
      return null;
    }

    return (
      <OverlayTrigger trigger="click"
                      key={'left'}
                      placement={'left-start'}
                      rootClose={true}
                      show={false}
                      rootCloseEvent='click'
                      transition={true}
                      defaultShow={true}
                      overlay={ this.renderPopoverList() }
                    >
        { triggerSection }
      </OverlayTrigger>
      );
  }

  renderCurrentlyLoggedIn = (selectedPractice, selectedRole) => {
    if (!selectedRole || !selectedPractice || (isMobileOnly && selectedPractice)) {
      return <div className="flex-container title-bar-currently-logged" onClick={ () => { this.props.userActions.signOut(); NavigationActions.navigateTo(routes.SIGN_IN) }}>
        <div style={{ fontSize: 12, color: '#1dc2ff' }}>{ 'Sign Out' }</div>
      </div>
    }

    let selectedPracticeInfo = this.props.practice;
    let roleLabel            = this.mapRoleToLabel(selectedRole);
    let practice_code        = selectedPracticeInfo && selectedPracticeInfo.code ? selectedPracticeInfo.code.toUpperCase() : '';
    let subscription_type    = selectedPracticeInfo && selectedPracticeInfo.subscription && selectedPracticeInfo.subscription.subscription_type ? selectedPracticeInfo.subscription.subscription_type : '';

    let display_code         = subscription_type === 'CORE' || subscription_type === 'ENTERPRISE';
    let practice_type        = subscription_type === 'INSTANT'      ? 'Instant' : '';
        practice_type        = subscription_type === 'INSTANT_PAID' ? 'Instant+' : practice_type;
        practice_type        = subscription_type === 'CORE'         ? 'Professional'    : practice_type;
        practice_type        = subscription_type === 'ENTERPRISE'   ? 'Enterprise'      : practice_type;

    let is_enterprise        = subscription_type === 'ENTERPRISE';
    let enterprise           = selectedPracticeInfo && selectedPracticeInfo.enterprise ? selectedPracticeInfo.enterprise : null;
    let requested_enterprise = false;

    if (enterprise && !is_enterprise) {
      if(!enterprise.content.contacted) {
        requested_enterprise = true;
      }
    }

    let hide_upgrade         = subscription_type === 'ENTERPRISE' || requested_enterprise;

    if (selectedPracticeInfo && roleLabel) {
      return <div className='flex-container-row'>
      <div className='flex-container-column' style={{ alignItems: 'flex-end', justifyContent: 'center', marginRight: 15 }}>
        <span style={{ fontSize: 15,  color: 'grey' }}>{ practice_type }</span>

        { hide_upgrade ? null : <span className='icon-button'
              style={{ marginTop: -4, fontSize: 13 }}
              onClick={ () => {
                let screen_props = {
                  is_updgrade: true,
                }
                history.push({ pathname: routes.PRACTICE_PLANS, state: { props: screen_props } })
              }}>{ 'Upgrade' }</span> }

      </div>
      <div className="flex-container title-bar-currently-logged" onClick={ () => { NavigationActions.navigateTo(routes.MY_ACCOUNT) }}>
        <div style={{ fontSize: 14, color: '#575757' }}>{ selectedPracticeInfo.name }</div>
        <div style={{ fontSize: 12, color: '#1dc2ff' }}>{ roleLabel }</div>
      </div>
      </div>
    }

    if (selectedPracticeInfo && selectedRole && selectedRole === 'front_desk') {
      return <div className='flex-container-row'>
        <div className='flex-container-column' style={{ alignItems: 'flex-end', paddingTop: 6, marginRight: 15 }}>
          <span style={{ fontSize: 14, fontWeight: 'bold', color: 'grey' }}>{  practice_code ? 'Practice Code' : '' }</span>
          <span style={{ color: '#1dc2ff', marginTop: -4, fontSize: 15 }}>{ practice_code }</span>
        </div>
        <div className="flex-container title-bar-currently-logged" onClick={ () => { this.props.userActions.signOut(); NavigationActions.navigateTo(routes.SIGN_IN) }}>
          <div style={{ fontSize: 14, fontWeight: 'bold', color: '#494f52' }}>{ selectedPracticeInfo.name }</div>
          <div style={{ fontSize: 12, color: '#1dc2ff' }}>{ 'Sign Out' }</div>
        </div>
      </div>
    }

    return null
  }

  render() {

    let subscription = this.props.practice && this.props.practice.subscription ? this.props.practice.subscription : {};
    let plan_label   = this.getPlanLabel(subscription);

    return (
      <div className="title-bar-container flex-container flex-container-row flex-space-between flex-center-align">
        <div className='flex-container-row' style={{ alignItems: 'center' }}>
          { /* <img className="title-bar-logo" src={logo} alt="Icon Text" /> */ }
          <div className='flex-container-column' style={{ paddingLeft: 10 }}>
            <span style={{ fontSize: 34, fontWeight: 'bold', color: '#1dc2ff' }}>teletails</span>
            { plan_label && false ? <span style={{ fontSize: 10, color: 'grey' }}>{ plan_label }</span> : null }
          </div>
        </div>
        { this.props.hideCurrentInfo === true ? null : this.renderCurrentlyLoggedIn(this.props.selectedPractice, this.props.selectedRole) }
      </div>
    );
  }

  mapRoleToLabel = (role) => {
    switch (role) {
      case 'practice_manager':
        return 'Practice Manager';
      case 'practice_owner':
        return 'Practice Owner';
      case 'vet':
        return 'Veterinarian';
      case 'behaviorist':
        return 'Behaviorist';
      case 'admin':
        return 'Admin';
      case 'tech':
        return 'Tech';
      default:
        return '';
    }
  }

  getPlanLabel = (subscription) => {
    let subscription_type = subscription && subscription.subscription_type ? subscription.subscription_type : '';
    let label = '';

    let label_dict = {
      'INSTANT': 'Instant',
      'INSTANT_PAID': 'Instant+',
      'CORE': 'Professional',
      'ENTERPRISE': 'Enterprise'
    }

    label = label_dict[subscription_type];
    return label ? label.toUpperCase() : label;
  }

}

export default TitleBar
